import { timelinePropsSchema } from '../component-catalog.js';
export const timelineDefinition = {
    type: 'Timeline',
    category: 'domain',
    propsSchema: timelinePropsSchema,
    isDataBacked: true,
    columnRefManifest: ['label', 'date', 'description', 'icon'],
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Sequential timeline of dated events. Props: sourceDataset (required), mapping ({ label: string, date: string, description?: string, icon?: string }), orientation? ("horizontal" | "vertical").',
};
//# sourceMappingURL=Timeline.js.map